import React from 'react';
import { Modal, Box, Typography, Button, useTheme } from '@mui/material';

interface TermsOfUseDialogProps {
  open: boolean;
  onClose: () => void;
  pdfUrl: string;
}

const TermsOfUseDialog: React.FC<TermsOfUseDialogProps> = ({
  open,
  onClose,
  pdfUrl,
}) => {
  const theme = useTheme();

  const style = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50vw',
    bgcolor: 'background.paper',
    borderRadius: '0.5rem',
    boxShadow: 24,
    p: 4,
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          variant="h5"
          fontWeight={700}
          display="flex"
          justifyContent="center"
          gutterBottom
        >
          Terms of Use
        </Typography>
        <iframe
          src={pdfUrl}
          title="Terms of Use"
          width="100%"
          height="500px"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
        >
          <object
            data={pdfUrl}
            type="application/pdf"
            width="100%"
            height="500px"
          >
            <p>
              Your browser does not support embedded PDFs.
              <a href={pdfUrl} target="_blank" rel="noreferrer">
                Download the PDF
              </a>{' '}
              instead.
            </p>
          </object>
        </iframe>
        <Box
          sx={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}
        >
          <Button
            sx={{
              background: theme.palette.primary.cowbellBlue,
              fontWeight: 700,
              color: theme.palette.common.white,

              '&:hover': {
                background: theme.palette.primary.cowbellBlue,
              },
            }}
            variant="outlined"
            onClick={onClose}
            color="primary"
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default TermsOfUseDialog;
